import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var generateStyle = function generateStyle(componentTheme, props) {
  var errorList = props.errorList,
    showBorder = props.showBorder,
    isGroupError = props.isGroupError;
  var hasError = errorList.length > 0;
  return {
    errorsContainer: _objectSpread(_objectSpread({}, hasError && !isGroupError && {
      margin: componentTheme.errorBorderMargin,
      padding: componentTheme.errorBorderPadding
    }), hasError && showBorder && {
      border: "solid 1px ".concat(componentTheme.errorBorderColor),
      borderRadius: componentTheme.errorBorderRadius
    }),
    errorList: {
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'column'
    },
    error: {
      flex: '1 1 auto'
    },
    errorAlert: {
      width: '100%'
    }
  };
};
export default generateStyle;